import axios from "axios";
import { config } from "./ConfigService";

class EmailDomainService {
  getRestrictedDomains() {
    return axios.get(`${config.API_URL}/admin/registration/restrictedDomains`);
  }
  
  updateRestrictedDomains(domains) {
    return axios.patch(`${config.API_URL}/admin/registration/restrictedDomains`, domains);
  }
}

export default new EmailDomainService();
